import * as React from 'react';
import { InlineText2, Input } from '@cian/ui-kit';
import { formatPhoneNumber } from '../../../utils/formatters';
import { onKeyDown } from '../../../utils/keyboard';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PhoneInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var handleChangeValue = function handleChangeValue(_, value) {
    var newValue = value.replace(/[^\d]/g, '');
    if (newValue.length > 10) {
      return;
    }
    onChange(newValue);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: /*#__PURE__*/_jsx(InlineText2, {
        children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440"
      })
    }), /*#__PURE__*/_jsx(Input, {
      type: "text",
      leftAdornment: /*#__PURE__*/_jsx("div", {
        className: styles['prefix'],
        children: /*#__PURE__*/_jsx(InlineText2, {
          children: "+7"
        })
      }),
      value: formatPhoneNumber(value),
      onKeyDown: onKeyDown,
      onChange: handleChangeValue
    })]
  });
}